/* eslint-disable prettier/prettier */
export enum EVENT_NAME {
  ADD_PAYMENT_INFO = 'add_payment_info',
  ADD_SHIPPING_INFO = 'add_shipping_info',
  ADD_TO_CART = 'add_to_cart',
  ADD_TO_WISHLIST = 'add_to_wishlist',
  BEGIN_CHECKOUT = 'begin_checkout',
  CALL_TO_BUY = 'call_to_buy',
  CLICK_LOGO_140th = 'click_logo_140th',
  CTA_DISCOVER = 'cta_discover',
  CONTACT = 'contact',
  GENERATE_LEAD = 'generate_lead',
  INTENTION_BOOK_APPT = 'intention_book_appt',
  INTENTION_REGISTER_WATCH = 'intention_register_watch',
  INTENTION_VIEW_CART = 'intention_view_cart',
  INTENTION_WARRANTY_EXTENSION = 'intention_warranty_extension',
  LOCATOR_PIN_DETAILS = 'locator_pin_details',
  LOGIN = 'login',
  NEWSLETTER_SUBSCRIPTION = 'newsletter_subscription',
  NOTIFY_ME = 'notify_me',
  PAGE_VIEW = 'page_view',
  POPIN_CLOSE = 'popin_close',
  POPIN_VIEW = 'popin_view',
  PURCHASE = 'purchase',
  REGISTERED_WATCH = 'registered_watch',
  REMOVE_FROM_CART = 'remove_from_cart',
  REMOVE_FROM_WISHLIST = 'remove_from_wishlist',
  REVIEW_ORDER = 'review_order',
  SEARCH = 'search',
  SELECT_ITEM = 'select_item',
  SELECT_PROMOTION = 'select_promotion',
  SERVICE_COMPLETE = 'service_complete',
  SERVICE_PERSONAL_DATA = 'service_personal_data',
  SERVICE_REQUEST = 'service_request',
  SERVICE_REASON = 'service_reason',
  SERVICE_SHIPPING = 'service_shipping',
  SIGN_UP = 'sign_up',
  VIDEO_COMPLETE = 'video_complete',
  VIDEO_START = 'video_start',
  VIDEO_PROGRESS = 'video_progress',
  VIEW_CART = 'view_cart',
  VIEW_ITEM = 'view_item',
  VIEW_ITEM_LIST = 'view_item_list',
  VIEW_PROMOTION = 'view_promotion',
  WISHLIST_COMPARISON_START = 'wishlist_comparison_start',
  CTA_NFT = 'cta_nft',
  BOOK_AN_APPT = 'book_an_appt',
  GUEST_CHECKOUT = 'guest_checkout',
  GUEST_SERVICE_JOURNEY = 'guest_service_journey',
  CATALOG_DOWNLOAD = 'catalog_download',
  SERVICE_STATUS = 'service_status',
}

export const menuCategoryMapping: {
  [key: string]: string;
} = {
  '/straps/': 'straps',
  '/watches/gifting/': 'gifts',
  '/collections/': 'watches',
  '/watches/': 'watches',
  // '/my-account/breitlingselect/': 'subscription',
  '/my-account/order/': 'check your order',
  '/service/': 'service',
  // '/nft/': 'nft',
  // '/sustainability/': '/sustainability/',
  '/about/': 'about',
  '/search/': 'search',
  '/my-account/login/': 'login or account creation interface',
  '/my-account/signin/': 'login or account creation interface',
  '/my-account/my-wishlist/': 'wishlist',
  '/my-account/': 'my account',
  '/shopping-bag/': 'shopping bag',
  '/store/checkout/': 'checkout your order',
  '/stores/': 'stores',
  '/140-years/': '140 years',
  '/campaigns/': 'about',
  // '/': 'homepage',
};

export const pageTypeMapping: {
  [key: string]: string;
} = {
  '/collections/': 'watch product list page - collections',
  '/novelties/': 'watch product list page - novelties ',
  '/collections/chronomat/': 'watch product list page - chronomat',
  '/collections/superocean/': 'watch product list page - superocean',
  '/collections/navitimer/': 'watch product list page - navitimer',
  '/collections/classic-avi/': 'watch product list page - classic avi',
  '/collections/professional/': 'watch product list page - professional',
  '/collections/superocean-heritage/':
    'watch product list page - superocean heritage',
  '/collections/avenger/': 'watch product list page - avenger',
  '/collections/top-time/': 'watch product list page - top time',
  '/collections/premier/': 'watch product list page - premier',
  '/watches/men/': 'watch product list page - men',
  '/watches/women/': 'watch product list page - women',
  '/watches/material/': 'watch product list page - find your breitling',
  '/watches/all/': 'watch product list page - all',
  '/watches/gifting/': 'watch product list page - gifts',
  '/watches/[collection]/[model]/[sku]': 'watch product detail page',
  '/watches/engraving/': 'product list personalize',
  '/watches/': 'watches',
  '/straps/all/': 'strap product list page - all',
  '/straps/packs/[slug]': 'strap product list page - packs',
  '/straps/rubber/': 'strap product list page - rubbers',
  '/straps/leather/': 'strap product list page - leather',
  '/straps/fabric/': 'strap product list page - fabric',
  '/straps/alligator/': 'strap product list page - alligator',
  // '/straps/gifting/': 'strap product list page - gifts',
  '/straps/[material]/[sku]': 'strap product detail page',
  '/straps/': 'straps',
  // '/': 'gifts',
  // '/': '4gift',
  // '/': 'subscription',
  // '/': 'subscription - product list page yearly',
  // '/': 'subscription - product list page monthly',
  // '/': 'subscription - product detail page',
  '/service/my-watch-needs-a-service/': 'service - my watch needs a service',
  '/service/our-services/': 'service - our services',
  '/service/service-prices/': 'service - prices',
  '/service/watch-care/': 'service - watch care',
  '/service/warranties/': 'service - international warranty',
  '/service/': 'service',
  // '/': 'Store locator',
  '/about/digital-passport/': 'NFT',
  '/about/sustainability/': 'sustainability',
  '/my-account/login/': 'login or account creation interface',
  '/my-account/my-details/': 'my account - my details',
  '/my-account/my-watches/': 'my account - my watches',
  '/my-account/order/': 'my account - my orders',
  '/my-account/my-wishlist/': 'my account - my wishlist',
  '/my-account/wishlist/': 'wishlist',
  // '/': 'my account - breitling select',
  // '/': 'my account - trade',
  '/my-account/sign-in/': 'account creation - form',
  '/my-account/': 'my account',
  // '/my-account/login/?t=/': 'account creation - to validate',
  // '/my-account/login/?r=1&n=0&t=/': 'account creation - validated',
  '/store/order-status/': 'check your order',
  '/store/shopping-bag/': 'shopping bag',
  // '/checkout': 'checkout - express',
  '/store/checkout/delivery/': 'checkout - shipping info',
  '/store/checkout/review/': 'checkout - review order',
  '/store/checkout/payment/': 'checkout - payment info',
  '/store/order/payment/': 'checkout - payment info',
  '/store/order/confirmation/': 'checkout - transaction confirmed',
  '/stores/appointment/': 'stores - appointment',
  '/store/global-e/checkout/': 'checkout - global-e',
  '/about/': 'about',
  '/search/[[...urlParts]]': 'search results',
  // '/': 'find your breitling',
  '/140-years/': '140 years - anniversary',
  // '/': 'other',
  // '/': 'homepage',
};

export const regExpMapping = {
  'watch product detail page': /^\/watches\/([^/]+)\/([^/]+)\/([^/]+)\/$/,
  'strap product list page - packs': /^\/straps\/packs\/([^]+)\/$/,
  'strap product detail page': /^\/straps\/([^/]+)\/([^/]+)\/$/,
  'account creation - to validate': /^\/my-account\/login\/?t=.*\/$/,
  'account creation - validated': /^\/my-account\/login\/?r=1&n=0&t=.*\/$/,
  'search results': /^\/search\/([^/]+)\/$/,
};

export const popinTitle = {
  forGift: '4gift',
  addStrap: 'addStrap',
  downloadCatalog: 'downloadCatalog',
  newsletter: 'newsletter',
  declinedQuote: 'declined quote',
  bookAppointment: 'book an appointment',
  engraving: 'engraving',
  notifyMe: 'notify me',
  login: 'login',
  nftAuthenticity: 'nft authenticity',
  watchHistory: 'watch history',
  myNft: 'my nft',
  transferMyOwnership: 'transfer my ownership',
};

export const marketEcom: {
  [key: string]: 'yes' | 'no';
} = {
  'UNITED ARAB EMIRATES': 'yes',
  AUSTRIA: 'yes',
  AUSTRALIA: 'yes',
  BELGIUM: 'yes',
  BULGARIA: 'yes',
  BAHRAIN: 'yes',
  CANADA: 'yes',
  SWITZERLAND: 'yes',
  CHINA: 'yes',
  CZECHIA: 'yes',
  GERMANY: 'yes',
  DENMARK: 'yes',
  SPAIN: 'yes',
  FINLAND: 'yes',
  FRANCE: 'yes',
  'UNITED KINGDOM': 'yes',
  GREECE: 'yes',
  'HONG KONG': 'yes',
  CROATIA: 'yes',
  HUNGARY: 'yes',
  ITALY: 'yes',
  JORDAN: 'yes',
  JAPAN: 'yes',
  KUWAIT: 'yes',
  LUXEMBOURG: 'yes',
  MALAYSIA: 'yes',
  NETHERLANDS: 'yes',
  NORWAY: 'yes',
  POLAND: 'yes',
  PORTUGAL: 'yes',
  QATAR: 'yes',
  ROMANIA: 'yes',
  'SAUDI ARABIA': 'yes',
  'SOUTH AFRICA': 'yes',
  SWEDEN: 'yes',
  SINGAPORE: 'yes',
  SLOVENIA: 'yes',
  SLOVAKIA: 'yes',
  THAILAND: 'yes',
  'TAIWAN REGION': 'yes',
  'UNITED STATES': 'yes',
};
